QuestionnaireRequest.Building = {}